export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}

export const compareStrings = (a: string, b: string): number =>
  a < b ? -1 : a > b ? 1 : 0;

export const formatInt = (num: number | string | null | undefined): string => {
  if (num == null) {
    return '';
  } else if (typeof num === 'number') {
    return num.toLocaleString('en-GB', { maximumFractionDigits: 0 });
  } else {
    return parseInt(num).toLocaleString('en-GB', { maximumFractionDigits: 0 });
  }
};

export const formatPerc = (num: number | string | null | undefined): string => {
  if (num == null) {
    return '';
  } else if (typeof num === 'number') {
    return `${(num * 100).toLocaleString('en-GB', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    })}%`;
  } else {
    return `${(parseFloat(num) * 100).toLocaleString('en-GB', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    })}%`;
  }
};

export const firstCap = (str: string): string =>
  str.charAt(0).toUpperCase() + str.substring(1);

export function formatIdNumber(idnumber: string): string {
  const match = idnumber.match(/(\d{6})\s*(\d{4})\s*(\d{3})/);
  if (match != null) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  } else {
    return idnumber;
  }
}

export const cleanIdnumber = (dirty: string): string =>
  dirty.replace(/\s+/g, '');

export function formatPhone(phone: string): string {
  const match = phone.match(/(\d{3})\s*(\d{3})\s*(\d{4})/);
  if (match != null) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  } else {
    return phone;
  }
}

export const formatDateString = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-ZA', { dateStyle: 'long' });
};

export const formatDateTime = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('en-ZA', { dateStyle: 'short', timeStyle: 'short' });
};
